import { __awaiter, __generator } from "tslib";
import { isWebView2 } from '@office-start/device-detection-utility';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { OfficeWorkload } from '@office-start/officehome-types';
/**
 * Functionality to check if marketing content targeted at
 * Surface devices should be shown.
 * @param workload
 */
export function shouldShowSurfaceContent(workload) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var featureGates, surfaceExpEnabled, isHwaLaunch, hwaNativeBridge, isSurface;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetchFeatureGates()];
                case 1:
                    featureGates = _c.sent();
                    surfaceExpEnabled = ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.surfaceExpGates) === null || _b === void 0 ? void 0 : _b.surfaceExpEnabled) || false;
                    isHwaLaunch = workload === OfficeWorkload.Hwa || isWebView2();
                    if (!(isHwaLaunch && surfaceExpEnabled)) return [3 /*break*/, 3];
                    return [4 /*yield*/, import('@office-start/hwa-native-bridge-service')];
                case 2:
                    hwaNativeBridge = _c.sent();
                    isSurface = hwaNativeBridge.isSurfaceDevice();
                    return [2 /*return*/, isSurface];
                case 3: return [2 /*return*/, false];
            }
        });
    });
}
//# sourceMappingURL=shouldShowSurfaceContent.js.map